import {Stepper} from "../../core/js/Stepper.ts";
import {$, $$, hide, show} from "../../core/js/Dom.ts";
import {$get} from "../../core/js/Ajax.ts";
import {fadeIn, fadeOut} from "../../core/js/Animate.ts";
import {updateDateFinPlus4An} from "../../core/js/Utils.ts";

document.addEventListener('DOMContentLoaded', () => {
    if (document.body.dataset.url === 'creation_homologation') {
        $$<HTMLButtonElement>('.stepper-next').forEach(button => button.disabled = true)
        const stepper = new Stepper('#stepper_homologation_formulaire')
        initActiviteSelect()
        const circuit = $('#id_circuit_fk')
        stepper.addEventListener('stepper:change', handleStepHomologationChanged)
        circuit?.addEventListener('change', (event) => {
            searchActivite(event)
            checkHomologationState()
            checkCanGoToNextStep(stepper.currentStep)
        })
        $('#id_objet_demande_homologation')?.addEventListener('change', () => {
            checkHomologationState()
            checkCanGoToNextStep(stepper.currentStep)
        })
        $('#id_activite_m2m')?.addEventListener('change', () => {
            checkCanGoToNextStep(stepper.currentStep)
        })
        const date_debut = $('#id_date_debut')
        date_debut?.addEventListener('change', updateDateFin)
        date_debut?.addEventListener('change', () => checkCanGoToNextStep(stepper.currentStep))
        const date_fin = $<HTMLFormElement>('#id_date_fin')
        date_fin?.setAttribute('disabled', "true")
        if (date_fin) date_fin._flatpickr._input.disabled = true
        $('#id_nom')?.setAttribute('disabled', "true")
    }
    initUserOrganisation()
})

function checkCanGoToNextStep(currentStep: number) {
    const form = $<HTMLFormElement>('#evenement-form');
    let canChange = false
    if (form) {
        const formData = new FormData(form)
        switch (currentStep) {
            case 1:
                if(formData.get('circuit_fk') && Number(formData.get('objet_demande_homologation')) >= 0 && formData.get('activite_m2m') && formData.get('date_debut')) {
                    canChange = true
                }
                break;
        }
    }
    $<HTMLButtonElement>(`[data-step="${currentStep}"] .stepper-next`)!.disabled = !canChange
    return canChange
}

function initActiviteSelect() {
    const selectElement = $<HTMLSelectElement>('#id_activite_m2m')!

    selectElement?.classList.remove('fr-select')

}

function showNotice(message: string) {
    $<HTMLElement>('#info-cerfa-text')!.innerHTML = message;
    hide($('#id-submit'))
}

function showCerfa(message: string) {
    $<HTMLElement>('#info-cerfa-text')!.innerHTML = message;
    show($('#id-submit'))
}

function handleStepHomologationChanged(event: Event) {
    const step = (event as StepperChangeEvent).detail.step
    if (step === 2) {
        searchForm()
    }
}


function searchForm() {
    const form = $<HTMLFormElement>('#evenement-form')
    if (form) {
        const formData = new FormData(form)
        const circuit = String(formData.get('circuit_fk'))
        const activites = String(formData.get('activite_m2m') || "")
        if (circuit !== "" && activites !== "") {
            const formulaire = "Homologation"
            const get_url = '/aide/CERFA/' + formulaire;
            $get(get_url, {embed: true}).then((data) => {
                if (data.body.search('CERFA N°') !== -1) {
                    showCerfa(data.body)
                } else {
                    showNotice(data.body)
                }
            });
        } else {
            showNotice('Veuillez remplir le formulaire')
        }
    }
}

function updateDateFin(event: DOMEvent<HTMLInputElement>) {
    const date_fin = $<HTMLInputElement>('#id_date_fin')
    const dateDebutInput = event.target
    if(dateDebutInput && date_fin) {
        updateDateFinPlus4An(dateDebutInput,date_fin)
    }
}

/**
 * verifie que la demande correspondent au circuit
 */
function checkHomologationState() {
    const form = $<HTMLFormElement>('#evenement-form')
    const report = $<HTMLElement>('#info-status-homologation')
    const reportMessage = $<HTMLElement>('#info-status-homologation-text')
    if (form && report && reportMessage) {
        const formData = new FormData(form)
        const circuit = String(formData.get('circuit_fk'))
        const objet_demande_homologation = String(formData.get('objet_demande_homologation'))
        const url = `/dossier/ajax/obtenir_homologation_via_circuit_id/`
        $get(url, {
            circuit_fk_id: circuit,
            objet_demande_homologation: objet_demande_homologation
        }).then(data => {
            if (data.body !== "") {
                reportMessage.innerHTML = data.body
                fadeIn(report)
                $<HTMLButtonElement>('.stepper-next')!.disabled = true
            } else {
                if (!report.classList.contains('d-none')) {
                    fadeOut(report)
                    if(checkCanGoToNextStep(1)) {
                        $<HTMLButtonElement>('.stepper-next')!.disabled = false
                    }
                }
            }
        })
    }
}

function searchActivite(event: DOMEvent<HTMLInputElement>) {
    const target = event.target
    if (target) {
        const id_circuit = target.value;
        const url = `/dossier/ajax/obtenir_activites_via_circuit_id/`
        $get(url, {circuit_fk_id: id_circuit}).then(data => {
            selectMultipleActivities(data.body.activites_homologations_valides)
        })
    }
}

function selectMultipleActivities(data: string[]) {
    const activitesInput = $<HTMLSelectElement>("#id_activite_m2m")
    if (activitesInput) {
        activitesInput.value = data.join(',')
        const options = activitesInput.options
        for (const element of options) {
            if (data.includes(element.value)) {
                element.setAttribute('selected', "selected")
                element.selected = true
            }
        }
        activitesInput.dispatchEvent(new Event('change'))
    }
}

function initUserOrganisation() {
    $<HTMLInputElement>('#id_user_contact')?.addEventListener('change', (event: DOMEvent<HTMLSelectElement>) => choiceUserOrganisation(event.target))
}

function choiceUserOrganisation(select: HTMLSelectElement) {
    // Fonction qui permet de remplir les champs nom, prénom, email et téléphone
    const value = select.value
    if (value === '0') {
        return
    }
    const utilisateur = window.Openscop.utilisateurs.find((user: any) => user.id == value)
    if (utilisateur) {
        if (select.id === 'id_user_contact') {
            $<HTMLInputElement>('#id_nom_contact')!.value = utilisateur.last_name
            $<HTMLInputElement>('#id_prenom_contact')!.value = utilisateur.first_name
            $<HTMLInputElement>('#id_tel_contact')!.value = ""
        }
    }
}